import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EditActionComponent } from './edit-action/edit-action.component';
import { ActionsRoutingModule } from './actions-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';



@NgModule({
  declarations: [
    EditActionComponent
  ],
  imports: [
    CommonModule,
    ActionsRoutingModule,
    FormsModule,
    ReactiveFormsModule
  ]
})
export class ActionsModule { }
